import React from "react";
import Procrastinacao from "../assets/Procrastinacao.jpeg";

const ProcrastinacaoPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={Procrastinacao}
            alt="Procrastinacao"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">
            Procrastinação
          </h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            <br />
            "(...) por pensarem ansiosamente no futuro, esquecem do presente de
            forma que acabam por não viver nem no presente nem no futuro. E
            vivem como se nunca fossem morrer... e morrem como se nunca tivessem
            vivido." Você já deve ter ouvido essa frase em algum lugar, né?! 🧐
            <br />
            <br />
            Muitas vezes, a procrastinação representa algo mais profundo. Pode
            estar ligado a algum medo... Do arrependimento? Do erro? Da culpa?
            Importante é poder trabalhar no autoconhecimento, para entender os
            seus bloqueios, gatilhos e ansiedades.
            <br />
            <br />
            O que acha de dar o próximo passo?
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProcrastinacaoPage;
